import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  connect() {
    window.addEventListener("click", this.boundCloseOnClickOutside)
    window.addEventListener("keydown", this.boundCloseOnEscape)
    this.updateExpandedState()
  }

  disconnect() {
    window.removeEventListener("click", this.boundCloseOnClickOutside)
    window.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  toggle() {
    this.element.classList.toggle("is-active")
    this.updateExpandedState()
  }

  close() {
    this.element.classList.remove("is-active")
    this.updateExpandedState()
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.element.classList.contains("is-active")) {
      this.close()
      this.triggerElement?.focus()
    }
  }

  updateExpandedState() {
    this.triggerElement?.setAttribute("aria-expanded", this.element.classList.contains("is-active").toString())
  }

  get triggerElement() {
    return this.element.querySelector('[data-action~="dropdown#toggle"]')
  }
}
